import './Button.scss';

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default class Button extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
        noStyles: PropTypes.bool,
        cancelStyles: PropTypes.bool,
        type: PropTypes.string
    };

    render() {
        let { cancelStyles, noStyles, type, ...otherProps } = this.props;
        return (
            <button {...otherProps}
                    type={type || 'button'}
                    className={classNames('c-button', this.props.className, {
                        'a-button--cancel-styles': cancelStyles === true,
                        'a-button--no-styles': noStyles === true
                    })}>
                {this.props.children}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Button/index.js